import * as React from 'react';

import { SimpleDYSlider } from '../../SimpleSlider/SimpleDYSlider';

export const DYContainer: React.FC<{ id: string; dyContainerId?: string }> = ({ id, children, dyContainerId }) => {
  //TODO remove "id: string;" from here and DYSliderContainer completely once contentful migration is done
  return (
    <div data-testid="dy-container">
      <div id={dyContainerId || id}>{children}</div>
    </div>
  );
};

export const DYSliderContainer: React.FC<{ id: string; dyContainerId?: string }> = ({ id, dyContainerId }) => {
  return (
    <div data-testid="dy-slider-container">
      <DYContainer id={id} dyContainerId={dyContainerId}>
        <SimpleDYSlider className="slider" shownItems={[3, 3, 5, 6, 6, 9]} />
      </DYContainer>
    </div>
  );
};
